import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import SkylineLogo from "../img/skyline_logo_transparent.png";

class NavSide extends Component {
    state = {}
    render() {
        const activeClass = (route) => {
            return window.location.pathname.toLowerCase() + window.location.search.toLowerCase() === route.toLowerCase() ? "activeli" : null;
        };

        const isDefaultClass = () => {
            return !window.location.search.toLowerCase().includes("iscloudprocessing=") && window.location.pathname.toLowerCase().includes("account") ? "LicensePackagesActiveli" : "";
        }
        return (
            <nav className="side-nav sideNav">
                <div className="side-wrapper">
                    <div className='navSideLogo'>
                        <img src={SkylineLogo} style={{ width: '180px' }} />
                    </div>
                    <div className="nav-wrapper">
                        <ul className="nav flex-column">
                            <li className="nav-header pt-4">
                                <span className='text-uppercase' style={{ fontSize: '12px' }}>Cloud Services</span>
                            </li>
                            <li id="licensePackagesLiMenuNavSide" className={"nav-item " + activeClass("/store/account?isCloudProcessing=false") + " " + isDefaultClass()}>
                                <a
                                    href="account?isCloudProcessing=false"
                                    id='licensePackagesaMenuNavSide'
                                    className="nav-link navSideLink"
                                >
                                    <span id='licensePackagesSpanMenuNavSide' className="title">License Packages</span>
                                </a>
                            </li>
                            <li id='cloudProcessingLiMenuNavSide' className={"nav-item " + activeClass("/store/account?isCloudProcessing=true")}>
                                <a
                                    href="account?isCloudProcessing=true"
                                    id="cloudProcessingaMenuNavSide"
                                    className="nav-link navSideLink"
                                >
                                    <span id='cloudProcessingSpanNavSide' className="title">Cloud Processing</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div className='bottomNavSide'>
                        <ul className="nav flex-column">
                            <li
                                id="contactSupportliNavSide" className={"nav-item " + activeClass("/store/")}
                            >
                                <a id="contactSupportaNavSide" href={"https://support.skylinesoft.com/hc/en-us/requests/new?tf_subject=SkylineCloud Account&tf_anonymous_requester_email=" + this.props.email + "&tf_360015036959=product:skylinecloud"} onClick={() => { }} className="nav-link navSideLink bottomNavSideLink" target="_blank">
                                    <i id='contactSupportiNavSide' className="icon material-icons" style={{ fontSize: '17px' }}> headset_mic </i>
                                    <span id='contactSupportSpanNavSide' className="title">Contact Support</span>
                                </a>
                            </li>
                            <li
                                id='KnowledgeBaseliNavSide' className={"nav-item " + activeClass("/store/")}
                            >
                                <a id='KnowledgeBaseaNavSide' href="https://support.skylinesoft.com/hc/en-us" onClick={() => { }} className="nav-link navSideLink bottomNavSideLink" target="_blank">
                                    <i id='KnowledgeBaseiNavSide' className="icon material-icons" style={{ fontSize: '17px' }}> school </i>
                                    <span id='KnowledgeBaseSpanNavSide' className="title">Knowledge Base</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        );
    }
}

export default NavSide;